var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddimg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3 0.750031H5.65002C2.65002 0.750031 0.75 2.89006 0.75 5.91006V14.1C0.75 17.1 2.63002 19.26 5.65002 19.26H14.3C17.3 19.26 19.2 17.12 19.2 14.1V5.95999C19.21 2.88999 17.33 0.750031 14.3 0.750031Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69999 6.78997C8.69998 7.15629 8.59121 7.51446 8.38749 7.81891C8.18376 8.12335 7.89426 8.36046 7.55564 8.50018C7.21701 8.6399 6.84452 8.67589 6.48539 8.6037C6.12625 8.5315 5.79663 8.35439 5.5383 8.09466C5.27998 7.83493 5.10459 7.50435 5.03434 7.14483C4.96409 6.78531 5.00216 6.41299 5.14371 6.07513C5.28527 5.73727 5.5239 5.44896 5.82944 5.24688C6.13499 5.04481 6.49364 4.93802 6.85996 4.94C7.10244 4.94 7.34255 4.9879 7.56644 5.08099C7.79033 5.17408 7.99359 5.31056 8.16459 5.48248C8.33558 5.6544 8.4709 5.85843 8.56278 6.08282C8.65466 6.30722 8.7013 6.5475 8.69999 6.78997V6.78997Z",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.21 12.95C18.2811 12.0076 17.2779 11.1415 16.21 10.3601C15.6857 10.0561 15.0641 9.96657 14.4753 10.1101C13.8864 10.2535 13.3758 10.619 13.05 11.1301C12.28 12.1301 11.81 13.45 10.65 14.07C9.23002 14.85 8.39001 13.6 7.20001 13.07C6.01001 12.54 4.86998 13.52 4.09998 14.47C3.32998 15.42 2.54 16.38 1.75 17.33",
    stroke: "#200E32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.96,
    height: 19.95,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddimg);
export default __webpack_public_path__ + "static/media/addimg.929a5d76d018af62591c4ada6736e605.svg";
export { ForwardRef as ReactComponent };